import { COLORS } from '../../constant';

export function PensionProIcon({
  color = COLORS.GRAY.GRAY_600,
}: {
  color?: string;
}) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="2" width="16" height="16" rx="3" fill={color} />
      <path
        d="M6.5 5H10.6497C11.9956 5 12.9783 5.29836 13.5978 5.89509C14.2173 6.49182 14.5271 7.32297 14.5271 8.38855C14.5271 8.91077 14.455 9.37963 14.3108 9.79512C14.1738 10.1994 13.9401 10.5642 13.6299 10.8581C13.3199 11.1513 12.9194 11.3751 12.4282 11.5294C11.937 11.6837 11.3389 11.7609 10.6337 11.7611H7.84586V14.83H6.5V5ZM10.4575 10.5943C10.9381 10.5943 11.3494 10.5597 11.6912 10.4904C12.033 10.4212 12.3107 10.3066 12.5243 10.1468C12.741 9.98262 12.903 9.75699 12.989 9.49944C13.0851 9.22772 13.1332 8.88407 13.1332 8.46847C13.1332 8.05288 13.0904 7.70124 13.005 7.41354C12.9289 7.14139 12.7792 6.89534 12.5724 6.70228C12.3694 6.51595 12.097 6.38008 11.7553 6.29468C11.4135 6.20928 10.9809 6.16666 10.4575 6.16681H7.84586V10.5943H10.4575Z"
        fill="white"
      />
    </svg>
  );
}
